module.exports = "app.service(\"Lang\",[\"Resty\",function(Resty){return Resty(\"langs\",\"dictionaries\");}]);"